import { useSearchParams } from 'react-router'

type Result<T extends object> = [T, (newValues: T) => void]

export const useSearchParamsState = <T extends { [key: string]: string }>(defaultValues: T): Result<T> => {
  const [params, setParams] = useSearchParams(defaultValues)

  const values: { [key: string]: string } = {}
  for (const [key, value] of params.entries()) {
    values[key] = value
  }

  return [{ ...defaultValues, ...values } as T, setParams]
}
